import { Network } from '@puzzlehq/sdk';
import { getCountryData, TCountryCode } from 'countries-list';
import { networkPath } from '@puzzlehq/types';
import dayjs from 'dayjs';

export const getShortenedCountryName = (countryCode: string) => {
  const name = getCountryData(countryCode as TCountryCode).name;
  if (name.length > 8) return countryCode;
  return name;
};

export const ALEO_NETWORK_URL = import.meta.env.VITE_ALEO_NETWORK_URL;

export const getNetworkUrl = (network: Network): string => {
  return `${ALEO_NETWORK_URL}/${networkPath(network)}`;
};

export const getTimeDiffString = (end: Date, start: Date) => {
  let totalSeconds = dayjs(end).diff(dayjs(start), 'seconds');
  const days = Math.floor(totalSeconds / 86400);
  totalSeconds %= 86400;
  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  let timeString = '';
  if (days > 0) timeString += `${days}d `;
  if (hours > 0 || (days > 0 && (minutes > 0 || seconds > 0)))
    timeString += `${hours}h `;
  if (minutes > 0 || (hours > 0 && seconds > 0))
    timeString += `${minutes.toString().padStart(2, '0')}m `;
  if (days === 0 && hours === 0 && (seconds > 0 || timeString === ''))
    timeString += `${seconds.toString().padStart(2, '0')}s`;

  return timeString.trim();
};

export type LoadingStatus = 'idle' | 'loading' | 'succeeded' | 'failed';
